import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import axiosInstance from "../axios";
import TabsetContact from "./tabset-Contact";
import AddBranch from "./AddBranch";

function ContactUs() {
	const [render1, setRender1] = useState(false);
	return (
		<>
			<Breadcrumb title="تواصل معنا" parent="لوحة التحكم" />
			<Container fluid={true}>
				<Row>
					<Col xl="12">
						<Card className="profile-card">
							<AddBranch render1={render1} setRender1={setRender1} />
							<CardBody>
								<TabsetContact render1={render1} setRender1={setRender1} />
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default ContactUs;
